import React from 'react';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';
import useStyles from "./styles";

function FormModal({ open, handleClose, title, footerContent, children, showIconClose = true, topBorder = true, disableBorder }) {

    const classes = useStyles();

    function handleOnclose() { handleClose() }

    return (
        <Modal
            className={classes.formModal}
            aria-labelledby={title}
            aria-describedby={title}
            open={open}
            onClose={handleOnclose}>
            <Fade in={open}>
                <div className={classes.formModalWrapper}>
                    <div className={`${classes.formModalContainer} ${!!(disableBorder) ? classes.formModalWithNoBorders : null}`}>
                        <div className={classes.formModalHeader}>
                            <p className={classes.formModalTitle}>{title}</p>
                            {showIconClose && (
                              <IconButton
                                  variant="contained"
                                  onClick={handleOnclose}>
                                  <CloseIcon className={classes.headerColor} />
                              </IconButton>)
                            }
                        </div>
                        <div className={ topBorder ? classes.formModalBody : classes.formModalBodyNoTopBorder}>
                           {children}
                        </div>
                        {footerContent && <div className={classes.formModalFooter}>
                            {footerContent}
                        </div>}
                    </div>
                </div>
            </Fade>
        </Modal>
    );
}

FormModal.propTypes = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    handleClose: PropTypes.func.isRequired,
    footerContent: PropTypes.func,
}

export default FormModal;
